//Local
export const API_URL = 
//  "http://127.0.0.1:5000/api";
//Local Para compartir con el equipo casa
//  "http://192.168.1.90:5000/api";
//Local Para compartir con el equipo trabajo
//  "http://192.168.0.51:5000/api";


//Producción
  "https://skybotnmpback.skyangel.com.mx";

// David local (sin /api porque las rutas no tienen ese prefijo)
//  'http://127.0.0.1:8000';